import { endOfMonth, formatISO, parseISO, startOfMonth } from 'date-fns';

import { range } from 'lodash';

export interface SplitDate {
  year: number | '';
  month: number | '';
  day: number | '';
}

export const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const getYearChoices = (offset = 0, size = 50): number[] => {
  const start = new Date().getFullYear() - offset;
  return range(start, start - size, -1);
};

export const getDateISOString = ({ year, month, day }: SplitDate): string => {
  if (year.toString().length !== 4) {
    throw new Error('Year must be 4 digits');
  }
  if (![1, 2].includes(month.toString().length)) {
    throw new Error('Month must be 1 or 2 digits');
  }
  if (![1, 2].includes(day.toString().length)) {
    throw new Error('Day must be 1 or 2 digits');
  }
  return (
    `${year}-` +
    `${month.toString().length === 1 ? '0' + month : month}-` +
    `${day.toString().length === 1 ? '0' + day : day}`
  );
};

export const parseDate = (date: SplitDate): Date => {
  try {
    const dateStr = getDateISOString(date);
    return parseISO(dateStr);
  } catch (e) {
    return parseISO('Invalid Date');
  }
};

export const getFirstOfMonth = () => {
  return formatISO(startOfMonth(new Date()), { representation: 'date' });
};

export const getLastOfMonth = () => {
  return formatISO(endOfMonth(new Date()), { representation: 'date' });
};
